document.addEventListener('DOMContentLoaded', function() {
  if (!window.mz) {
    return
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  const simulateClick = function (elem) {
    const evt = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
    var canceled = !elem.dispatchEvent(evt);
  };  
  function onAutocompleteClose() {
    const searchElement = document.getElementsByClassName('Search__Close');
    if (searchElement && searchElement.length > 0) {
      simulateClick(searchElement[0]);
    }
  }
  if (mz.suggest && mz.suggest.$bus) {
    mz.suggest.$bus.on('autocomplete-close', onAutocompleteClose)
  }   
  function afterUpdate() {
    // placeholder
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate)
  }
})
